import PropTypes from "prop-types";
import React from "react";
import TimeOffRequestDialogDesktop from "./TimeOffRequestDialogDesktop.jsx";
import TimeOffRequestDialogMobile from "./TimeOffRequestDialogMobile.jsx";

const TimeOffRequestDialog = (props) => {
  const renderMobileTimeOffRequestDialog = () => {
    return (
      <TimeOffRequestDialogMobile
        isAdmin={props.isAdmin}
        isAdminPage={props.isAdminPage}
        timeOffRequest={props.timeOffRequest}
        onClickDialogClose={() => props.handleClickDialogClose()}
        onClickDialogOpen={() => props.handleClickDialogOpen()}
        isDialogOpen={props.isDialogOpen}
      />
    );
  };

  const renderDesktopTimeOffRequestDialog = () => {
    return (
      <TimeOffRequestDialogDesktop
        isAdmin={props.isAdmin}
        isAdminPage={props.isAdminPage}
        timeOffRequest={props.timeOffRequest}
        isDialogOpen={props.isDialogOpen}
        onClickDialogOpen={props.handleClickDialogOpen.bind(this)}
        onClickDialogClose={props.handleClickDialogClose.bind(this)}
      />
    );
  };

  return (
    <div>
      {props.isDialogOpen ? (
        <div>{props.isDesktopView ? renderDesktopTimeOffRequestDialog() : renderMobileTimeOffRequestDialog()}</div>
      ) : (
        ""
      )}
    </div>
  );
};
TimeOffRequestDialog.propTypes = {
  timeOffRequest: PropTypes.object.isRequired,
  isDialogOpen: PropTypes.bool.isRequired,
  handleClickDialogOpen: PropTypes.func,
  handleClickDialogClose: PropTypes.func.isRequired,
  isAdminPage: PropTypes.bool,
  isDesktopView: PropTypes.bool.isRequired,
};
export default TimeOffRequestDialog;
